module.exports = __webpack_public_path__ + "img/zhongguo.66c20b94.png";